import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import type {
  CommonAPI,
  PostalAreasGET,
  FeaturesCallback,
  PostalCodeAndPlaceName,
  ValidationRulesCallback,
} from '@modules/store/common/types/CommonAPI.interface';
import type FetchFeaturesConfig from '@modules/store/common/types/FetchFeaturesConfig.entity';
import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import APIMocked from './index.mock-api';
import APIReal from './index.real-api';

export default class API implements CommonAPI {
  private readonly api: any;

  constructor() {
    this.api = App.isMockedAPI() ? new APIMocked() : new APIReal();
  }

  fetchValidationRules(validationRulesConfig: FetchValidationRulesConfig, callback: ValidationRulesCallback): void {
    this.api.fetchValidationRules(validationRulesConfig, callback);
  }

  fetchFeatures(featuresConfig: FetchFeaturesConfig, callback: FeaturesCallback): void {
    this.api.fetchFeatures(featuresConfig, callback);
  }

  fetchPostalAreasByPostalCode(get: PostalAreasGET): Promise<PostalCodeAndPlaceName[]> {
    return this.api.fetchPostalAreasByPostalCode(get);
  }

  fetchCheckEmailInUse(email: string): Promise<boolean> {
    return this.api.fetchCheckEmailInUse(email);
  }

  verifyCellPhoneSend(cellPhone: string): Promise<string> {
    return this.api.verifyCellPhoneSend(cellPhone);
  }

  verifyCellPhoneVerify(cellPhone: string, token: string, code: string): Promise<boolean> {
    return this.api.verifyCellPhoneVerify(cellPhone, token, code);
  }
}
